import {Grid, useTheme} from "@mui/material";
import DealMenu from "../components/DealMenu";
import {Item} from "../../../domains/common/components/Item";
import RealtyFormContainer from "../components/Realty";
import {RolesEnums} from "../../../enums";
import {FilesListContainer} from "../components/FilesContainer";
import {XmlList} from "../components/XmlList";
import React from "react";
import {Responsible} from "../components/Responsible";
import DealCommentContainer from "../components/Comment";
import {dealData} from "../deal";
import {ParticipantsComponent} from "../components/Participants";
import { ChildStatmentContainer } from "../components/ChildStatement";

export function DealPrevRight1998() {
  const theme = useTheme();

  return (
    <Grid container spacing={1} sx={{mt: 0.2}}>
      <Grid item xs={12}>
        <DealMenu dealId={dealData.dealId}></DealMenu>
      </Grid>
      <Grid item xs={12}>
        <Item sx={{backgroundColor: theme.palette.background.default}}>
          <RealtyFormContainer values={dealData.realty}/>
        </Item>
      </Grid>

      <Grid item xs={6}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Item sx={{backgroundColor: theme.palette.background.default}}>
              <ParticipantsComponent role={RolesEnums.OWNER}/>
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={12}>
                <Item sx={{backgroundColor: theme.palette.background.default}}>
                  <FilesListContainer/>
                </Item>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{backgroundColor: theme.palette.background.default}}>
              <XmlList value={dealData.dealXmlStatementsList}/>
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{backgroundColor: theme.palette.background.default}}>
              <Responsible value={dealData.user}/>
            </Item>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Item sx={{ backgroundColor: theme.palette.background.default }}>
                <ParticipantsComponent role={RolesEnums.REPRESENTATIVE} />
              </Item>
            </Grid>
            <Grid item xs={12}>
              <Item sx={{ backgroundColor: theme.palette.background.default }}>
                <ParticipantsComponent role={RolesEnums.EXT_SIGNER} />
              </Item>
            </Grid>
            <Grid item xs={12}>
              <ChildStatmentContainer/>
            </Grid>
            <Grid item xs={12}>
              <Item sx={{backgroundColor: theme.palette.background.default}}>
                <DealCommentContainer />
              </Item>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
